var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00336 15.4962C9.00336 16.0456 9.45288 16.4951 10.0023 16.4951H13.9979C14.5473 16.4951 14.9969 16.0456 14.9969 15.4962V10.5016C14.9969 9.95222 14.5473 9.50271 13.9979 9.50271H10.0023C9.45288 9.50271 9.00336 9.95222 9.00336 10.5016V15.4962ZM14.9969 8.00434H13.7482L13.3936 7.64973C13.3037 7.55982 13.1738 7.50488 13.044 7.50488H10.9562C10.8264 7.50488 10.6965 7.55982 10.6066 7.64973L10.252 8.00434H9.00336C8.72866 8.00434 8.50391 8.2291 8.50391 8.5038C8.50391 8.7785 8.72866 9.00326 9.00336 9.00326H14.9969C15.2716 9.00326 15.4963 8.7785 15.4963 8.5038C15.4963 8.2291 15.2716 8.00434 14.9969 8.00434Z",
    fill: "white",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic_trash.911e86cefa39d657b87e167a42c4f608.svg";
export { ForwardRef as ReactComponent };